import { useQuery } from '@tanstack/react-query';
import createQueryRequest from 'services/createQueryRequest';
import useAPI from 'services/useAPI';

export const alarmKeys = {
  all: ['alarms'],
  alarms: () => [...alarmKeys.all],
  alarm: (id) => [...alarmKeys.alarms(), id]
};


export const useAlarms = () => {
  const api = useAPI();
  const alarmsQuery = useQuery({
    queryKey: alarmKeys.alarms(),
    queryFn: createQueryRequest(api.core.getAlarms),
    initialData: [],
    retry: 1
  });
  return { alarmsQuery, alarms: alarmsQuery.data ?? [], isLoading: alarmsQuery.isLoading };
};
